import { Pipe, PipeTransform, inject } from '@angular/core';
import {PostalCodeFormatPipe} from './postal-code-format.pipe';
import {ProjectRelation} from '../models/project-relation';

@Pipe({
    name: 'clipboardFormatRelationAddress',
    standalone: false
})
export class ClipboardFormatRelationAddressPipe implements PipeTransform {
    private postalCodeFormatPipe = inject(PostalCodeFormatPipe);


    transform(relation: ProjectRelation): string {
        return `${relation.street} ${relation.houseNumber} \n ${this.postalCodeFormatPipe.transform(relation.postalCode)} ${relation.city}`
    }

}
